import { arraySchema, objectSchema } from "vue-utils"
import { Nullable, type Id, type SortDirection } from "."
import { VtsLogSummary } from "./vts/VtsLogSummary"

export interface SearchVtsResult {
	globalTotal: number
	totalItems: number
	pageSize: number
	totalPages: number

	logs: VtsLogSummary[]
}

export const SearchVtsResult = objectSchema<SearchVtsResult>({
	globalTotal: Number,
	totalItems: Number,
	pageSize: Number,
	totalPages: Number,

	logs: arraySchema(VtsLogSummary),
})

export interface SearchVtsRequest {
	pageSize: number
	page: number
	filter: SearchVtsFilter
	sortBy: Nullable<VtsSortBy>
	sortDirection: Nullable<SortDirection>
}

export interface SearchVtsFilter {
	fromIds: Id[]
	toIds: Id[]
}

export enum VtsSortBy {
	LogTime = "logTime",
	EditedAt = "editedAt",
	From = "from",
	To = "to",
}
